import React from 'react'
import FloorAssignListTable from './Components/FloorPlanListTable';
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { Link } from 'react-router-dom';

const FloorAssignList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Floor Assign List</HeadingOne>
                    <div>
                        <Link className={`btn btn-primary me-2`} to={'/admin/floor-list/add-floor'}>Add Floor</Link>
                        <AddItemBtn url="assign-floor" title="Assign Floor" />
                    </div>
                </>
            }>

            <div className="col-12">
                <div className="alert alert-primary" role="alert">
                    <ol className="mb-0">
                        <li>Add Floor First To Assign Floor</li>
                    </ol>
                </div>
            </div>

            {/* Table section */}
            <div className="col-12">
                <FloorAssignListTable />
            </div>
        </PageBody>
    );
};

export default FloorAssignList
